import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { Tab } from 'react-tabs';

const ProfileTab = styled(Tab)(
  ({ theme }) => css`
    border: 1px solid transparent;
    border-bottom-color: ${theme.colors.grays[100]};
    background: ${theme.colors.grays[100]};
    border-radius: ${theme.radii.sm};
    display: block;
    position: relative;
    padding: ${theme.space.xs} ${theme.space.md};
    border: 0;
    color: ${theme.colors.blue};
    transition-property: background, color;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
    cursor: pointer;

    &[aria-selected='true'] {
      border-radius: ${theme.radii.md} ${theme.radii.md} 0 0;
      border-bottom-color: ${theme.colors.white};
      background: ${theme.colors.white};
      color: ${theme.colors.legacyCharcoal};
      box-shadow: ${theme.elevations[1]};

      // Used to cover box-shadow bottom
      &:after {
        content: '';
        position: absolute;
        height: 10px;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 5px;
        bottom: -4px;
        background-color: ${theme.colors.white};
      }
    }
  `
);

export default ProfileTab;
// This is to let the Tabs component know this is a custom Tab

ProfileTab.tabsRole = 'Tab';
